import React, { useCallback } from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { useQueryClient } from '@tanstack/react-query';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import {
  MultiDropdown,
  useMultiDropdown,
} from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import Api from '../../lib/api';

type Props = {
  apiClient: Api;
  testId: string;
  label: string;
};

const Disciplines = ({ apiClient, testId, label }: Props) => {
  const { watch, setValue } = useFormContext();
  const queryClient = useQueryClient();

  const selectedDisciplines = watch('disciplines');

  const fetchItems = useCallback(
    async (queryKey: string[], fetchQuery: () => Promise<Item[]>) => {
      const cachedData: Item[] | null | undefined =
        queryClient.getQueryData(queryKey);
      if (cachedData) {
        return { items: cachedData };
      }

      const items = await queryClient.fetchQuery({
        queryKey,
        queryFn: () => fetchQuery(),
      });

      return { items };
    },
    [queryClient]
  );

  const fetchDisciplines = useCallback(
    async (term: string) => {
      return await fetchItems(['disciplines', term], () =>
        apiClient.fetchDisciplines(term)
      );
    },
    [apiClient, fetchItems]
  );

  const disciplineDropdownProps = useMultiDropdown({
    fetchItems: fetchDisciplines,
    selectedItems: selectedDisciplines,
    onSelectedItemsChange: (e) =>
      setValue('disciplines', e.selectedItems, { shouldDirty: true }),
    preventLoadOnMount: true,
  });

  return (
    <MultiDropdown dropdownProps={disciplineDropdownProps}>
      <MultiDropdown.Field data-provides={testId} label={label} />
      <MultiDropdown.Flyout />
    </MultiDropdown>
  );
};

export default Disciplines;
